<template>
	<h4></h4>
	<PSPDFKit
		v-bind:plantillaId="this.$route.params.id"
	/>
</template>

<script>

import PSPDFKit from '../../components/pspdfkit.vue';


export default {
	name: 'PdfViewerComponent',
	components: {
		PSPDFKit
	}
}
</script>